import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Inbox, CheckSquare, Timer, Flame, ArrowRight } from "lucide-react";

export default function Dashboard() {
  const [data, setData] = useState(null);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { (async () => setData((await api.get("/dashboard")).data))(); }, []);

  const cards = [
    { label: "Cards captured", value: data?.cards, to: "/everything", icon: Inbox },
    { label: "Open tasks", value: data?.open_tasks, to: "/tasks", icon: CheckSquare },
    { label: "Focus today (min)", value: data?.focus_minutes_today, to: "/focus", icon: Timer },
    { label: "Habits done today", value: `${data?.habits_done_today || 0}/${data?.habits_total || 0}`, to: "/habits", icon: Flame },
  ];

  return (
    <div className="min-h-screen px-10 pt-10 pb-16 relative">
      <div className="orb orb-orange" style={{ width: 500, height: 500, top: -180, right: -140, opacity: 0.16 }} />
      <div className="mb-8">
        <div className="text-white/40 text-xs uppercase tracking-widest">Welcome back</div>
        <h1 className="serif-italic text-6xl text-white/90 mt-2">Hello, {user?.name?.split(" ")[0]}.</h1>
        <p className="text-white/50 mt-2">Small, steady steps. Here is where you stand today.</p>
      </div>
      <div className="h-px bg-white/10 mb-8" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map(c => {
          const Icon = c.icon;
          return (
            <button key={c.label} onClick={() => nav(c.to)} className="card-base p-6 text-left hover:border-white/20" data-testid={`dash-${c.label}`}>
              <div className="flex items-center justify-between">
                <Icon size={18} className="text-white/50" />
                <ArrowRight size={14} className="text-white/30" />
              </div>
              <div className="serif-italic text-5xl mt-4" style={{ color: "var(--orange)" }}>{c.value ?? "—"}</div>
              <div className="text-xs uppercase tracking-widest text-white/40 mt-3">{c.label}</div>
            </button>
          );
        })}
      </div>

      <div className="text-xs uppercase tracking-widest text-white/40 mt-14 mb-3">Tomorrow's mind is built today</div>
      <div className="serif-italic text-2xl text-white/70">“You do not rise to the level of your goals, you fall to the level of your systems.”</div>
    </div>
  );
}
